import { useQuery } from '@tanstack/vue-query'
import { Ref } from 'vue'

import { explorerApi } from '~/api/client'
import {
  EvmInternalTrxGroupInfo,
  EvmInternalTrxGroupListInfo,
  EvmInternalTrxInfo
} from '~/api/repository'
import { transactionInternalListKey } from '~/api/service/query-keys.const'
import { IPagination } from '~/types/pagination.type'

export const useFetchTransactionInternalList = (pagination: Ref<IPagination>) => {
  return useQuery([ ...transactionInternalListKey, pagination ], (): Promise<ViewInternalTransaction> => {
    return explorerApi.trxController.getInternalTrxList({
      requestBody: {
        page: pagination.value.page,
        size: pagination.value.rowPerPage
      }
    }).then((res) => {
      return transactionListDto(res as EvmInternalTrxGroupListInfo)
    })
  })
}

type ViewInternalTrxInfo = EvmInternalTrxInfo & {
  value: string;
}

type ViewInternalTrxGroupInfo = EvmInternalTrxGroupInfo & {
  internalTrxList: Array<ViewInternalTrxInfo>;
}

export type ViewInternalTransaction = EvmInternalTrxGroupListInfo & {
  totalCount: string;
  viewCount: string;
  internalTrxGroupList: Array<ViewInternalTrxGroupInfo>
}

const transactionListDto = (listInfo: EvmInternalTrxGroupListInfo): ViewInternalTransaction => {
  return {
    ...listInfo,
    totalCount: setComma(listInfo.TCNT),
    viewCount: setComma(listInfo.VCNT),
    internalTrxGroupList: listInfo.INTRXLIST.map(listGroup => {
      return {
        ...listGroup,
        internalTrxList: listGroup.INTRXLIST.map(transaction => {
          return {
            ...transaction,
            value: setComma(setDigits(transaction.VA, 15))
          }
        })
      }
    })
  }
}